import { createFeatureSelector, createSelector } from '@ngrx/store';

import { StockCollectionHistoryState } from './stock-collection-history.reducers';

export const stockCollectionHistoryKey = 'stockCollectionHistory';
export const selectStockCollectionHistoryState =
  createFeatureSelector<StockCollectionHistoryState>(stockCollectionHistoryKey);

export const selectAllStockCollectionHistoryList = createSelector(
  selectStockCollectionHistoryState,
  (state: StockCollectionHistoryState) => {
    return state?.selected;
  }
);

export const selectStockCollectionHistoryListCriteria = createSelector(selectStockCollectionHistoryState, (state) => {
  return state?.criteriaObject;
});

export const selectStockCollectionHistoryTotalElements = createSelector(
  selectStockCollectionHistoryState,
  (state) => {
    return state?.totalElements;
  }
);
